import {Component, inject, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {ActivatedRoute, Router, RouterModule} from '@angular/router';
import {StorageService} from '../../services/storage/storage.service';
import {
  CreatorService,
  InstagramValuesSourceEnum,
  TikTokValuesSourceEnum, YouTubeValuesSourceEnum
} from '../../services/creator/creator.service';
import {firstValueFrom} from 'rxjs';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {AlertAlreadyConnectedComponent} from './atoms/alert-already-connected/alert-already-connected.component';
import {TokenService} from '../../services/token/token.service';

@Component({
  selector: 'app-connect',
  standalone: true,
  imports: [HttpClientModule, AlertAlreadyConnectedComponent, RouterModule],
  providers: [CreatorService, HttpClient, TokenService],
  templateUrl: './connect.component.html',
  styleUrl: './connect.component.scss'
})
export class ConnectComponent implements OnInit {


  /**
   *
   * Are we using the Autnehtic APIs or the Manual APIs?
   *
   */
  authentiationMode: 'manual' | 'authentic' = 'manual';

  storageService: StorageService = inject(StorageService);

  route: ActivatedRoute = inject(ActivatedRoute);

  currentConnections: {
    tiktok: {
      displayName: string;
      source: TikTokValuesSourceEnum
    } | null;
    instagram: {
      username: string;
      source: InstagramValuesSourceEnum
    } | null;
    youtube: {
      username: string;
      source: YouTubeValuesSourceEnum
    } | null;
    meta: string | null
  } | undefined;


  platforms: {
    title: string,
    icon: string,
    action: string,
  }[] = [
    {
      title: 'TikTok',
      icon: '../../../assets/tiktok-middle.svg',
      action: 'tiktok',
    },
    {
      title: 'Instagram',
      icon: '../../../assets/instagram.webp',
      action: 'instagram',
    },
    {
      title: 'Meta',
      icon: '../../../assets/instagram.webp',
      action: 'meta',
    },
    {
      title: 'YouTube',
      icon: 'assets/youtube-logo.webp',
      action: 'youtube',
    },
  ]

  alreadyConnectedError: {
    title: string,
    icon: string,
    action: string,
  } | undefined;

  tiktokConnectUrl: string | undefined;

  showToggle: boolean = false;

  toggleCount: number = 0;

  TikTokValuesSourceEnum = TikTokValuesSourceEnum;

  constructor(
    private router: Router,
    private creatorService: CreatorService,
    private tokenService: TokenService
  ) {
  }

  ngOnInit() {

    const businessId = this.route.snapshot.params['businessId'];
    const externalId = this.route.snapshot.params['externalId'];

    this.storageService.set('businessId', businessId);
    this.storageService.set('externalId', externalId);

    if (businessId && externalId) {
      this.getCurrentApplicableConnections(businessId, externalId)

      this.setTikTokUrl();

      // this.getTikTokOauth();
    }
  }

  async getCurrentApplicableConnections(businessId: string, externalId: string) {
    try {
      const currentConnections: any = await firstValueFrom(this.creatorService.getCurrentApplicableConnections(businessId, externalId));
      console.log('Current applicable connections: ', currentConnections);
      this.currentConnections = currentConnections;

      console.log('🧩🧩🧩 ConnectComponent - getCurrentApplicableConnections(): Current connections 🧩🧩🧩 ', this.currentConnections);

    } catch (currentConnectionsError) {
      console.warn('Error getting current applicable connections: ', currentConnectionsError);
    }
  }

  selectPlatform(action: string) {
    console.log('selectPlatform()', action);
    console.log('authentiationMode: ', this.authentiationMode);

    if (this.authentiationMode === 'manual') {
      switch (action) {
        case 'tiktok':
          if (this.hasPlatformConnected({
            title: 'TikTok',
            icon: '../../../assets/tiktok-middle.svg',
            action: 'tiktok'
          })) {
            this.alreadyConnected({title: 'TikTok', icon: '../../../assets/tiktok-middle.svg', action: 'tiktok'});
            return;
          }
          this.router.navigate(['/enter-tiktok']);
          break;
        case 'instagram':
          if (this.hasPlatformConnected({
            title: 'Instagram',
            icon: '../../../assets/instagram.webp',
            action: 'instagram'
          })) {
            this.alreadyConnected({title: 'Instagram', icon: '../../../assets/instagram.webp', action: 'instagram'});
            return;
          }
          this.router.navigate(['/enter-instagram']);
          break;
        case 'youtube':
          if (this.hasPlatformConnected({
            title: 'YouTube',
            icon: 'assets/youtube-logo.webp',
            action: 'youtube'
          })) {
            this.alreadyConnected({title: 'YouTube', icon: 'assets/youtube-logo.webp', action: 'youtube'});
            return;
          }
          this.router.navigate(['/enter-youtube']);
          break;
        case 'meta':
          // this.router.navigate(['/enter-meta']);
          break;
        default:
          break;
      }
    } else {
      switch (action) {
        case 'tiktok':
          console.log('this.tiktokConnectUrl: ', this.tiktokConnectUrl);

          if (this.canUpgradeTikTok({title: 'TikTok', icon: '../../../assets/tiktok-middle.svg', action: 'tiktok'})) {
            console.log('canUpgradeTikTok() => ', true);
            this.launchTikTokVersion2();
          } else {
            this.alreadyConnected({title: 'TikTok', icon: '../../../assets/tiktok-middle.svg', action: 'tiktok'});
          }
          break;
        case 'instagram':
          this.launchInstagram();
          break;
        case 'meta':
          this.launchMeta();
          break;
        case 'youtube':
          this.launchYoutube();
          break;
        default:
          break;
      }
    }
  }

  canUpgradeTikTok(platform: { title: string, icon: string, action: string }) {
    console.log('canUpgradeTikTok()', platform);
    console.log('currentConnections: ', this.currentConnections);
    if (this.currentConnections) {
      if (platform.action !== TikTokValuesSourceEnum.TIKTOK_API) {
        if (this.currentConnections.tiktok?.source === TikTokValuesSourceEnum.TIK_API) {
          console.log('canUpgradeTikTok() => ', true);
          return true;
        } else {
          console.log('canUpgradeTikTok() => ', false);
          return false;
        }
      } else {
        console.log('canUpgradeTikTok() => ', false);
        return false;
      }
    }
    console.log('canUpgradeTikTok() => ', false);
    return false;
  }

  hasPlatformConnected(platform: { title: string, icon: string, action: string }) {
    if (this.currentConnections) {

      if (platform.action === 'tiktok') {
        return this.currentConnections.tiktok !== null;
      } else if (platform.action === 'instagram') {
        return this.currentConnections.instagram !== null;
      } else if (platform.action === 'meta') {
        return this.currentConnections.meta !== null;
      } else if (platform.action === 'youtube') {
        return this.currentConnections.youtube !== null;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  getPlatformHandle(platform: { title: string, icon: string, action: string }) {
    if (this.currentConnections) {
      if (platform.action === 'tiktok') {
        return `@${this.currentConnections.tiktok?.displayName}`;
      } else if (platform.action === 'instagram') {
        return `@${this.currentConnections.instagram?.username}`;
      } else if (platform.action === 'meta') {
        return `@${this.currentConnections.meta}`;
      } else if (platform.action === 'youtube') {
        return `@${this.currentConnections.youtube?.username}`;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  launchTikTokVersion2() {
    // if (this.hasPlatformConnected({ title: 'TikTok', icon: '../../../assets/tiktok-middle.svg', action: 'tiktok' })) {
    //   this.alreadyConnected({ title: 'TikTok', icon: '../../../assets/tiktok-middle.svg', action: 'tiktok' });
    //   return;
    // }

    if (this.tiktokConnectUrl) {
      window.location.href = this.tiktokConnectUrl;
    }

  }

  async launchTikTok() {
    console.log('launchTikTok()');
    if (this.hasPlatformConnected({title: 'TikTok', icon: '../../../assets/tiktok-middle.svg', action: 'tiktok'})) {
      this.alreadyConnected({title: 'TikTok', icon: '../../../assets/tiktok-middle.svg', action: 'tiktok'});
      return;
    }

    try {
      // Use web-based OAuth flow instead of API redirect URL
      const client_key = environment.tiktok.clientKey;
      const redirect_uri = environment.tiktok.redirectUri;
      const scope = 'user.info.basic,user.info.profile,user.info.stats,video.list';
      const response_type = 'code';

      // Generate a secure random state
      let array = new Uint8Array(30);
      const csrfState = window.crypto.getRandomValues(array);
      const state = Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');

      const url = `https://www.tiktok.com/v2/auth/authorize/?client_key=${client_key}&response_type=${response_type}&scope=${scope}&redirect_uri=${redirect_uri}&state=${state}`;
      console.log('TikTok OAuth URL: ', url);

      window.location.href = url;
    } catch (error) {
      console.error('Error launching TikTok OAuth: ', error);
    }
  }

  async setTikTokUrl() {
    try {
      // Use web-based OAuth flow instead of API redirect URL
      const client_key = environment.tiktok.clientKey;
      const redirect_uri = environment.tiktok.redirectUri;
      const scope = 'user.info.basic,user.info.profile,user.info.stats,video.list';
      const response_type = 'code';

      // Generate a secure random state
      let array = new Uint8Array(30);
      const csrfState = window.crypto.getRandomValues(array);
      const state = Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');

      const url = `https://www.tiktok.com/v2/auth/authorize/?client_key=${client_key}&response_type=${response_type}&scope=${scope}&redirect_uri=${redirect_uri}&state=${state}`;
      console.log('TikTok OAuth URL: ', url);

      this.tiktokConnectUrl = url;
      console.log('TikTok OAuth URL: ', this.tiktokConnectUrl);
    } catch (error) {
      console.error('Error launching TikTok OAuth: ', error);
    }
  }

  async getTikTokOauth() {
    try {
      setTimeout(async () => {
        const oauthLink = await firstValueFrom(this.tokenService.getRedirectUrl());
        console.log('TikTok OAuth link: ', oauthLink);
        this.tiktokConnectUrl = oauthLink.url;
        console.log('TikTok OAuth URL: ', this.tiktokConnectUrl);
      }, 1000);
      // const oauthLink = await firstValueFrom(this.tokenService.getRedirectUrl());
      // console.log('TikTok OAuth link: ', oauthLink);
      // this.tiktokConnectUrl = oauthLink.url;
      // console.log('TikTok OAuth URL: ', this.tiktokConnectUrl);
    } catch (oauthLinkError) {
      console.error('Error getting TikTok OAuth link: ', oauthLinkError);
    }
  }

  getTikTokUrlUi() {
    if (this.tiktokConnectUrl) {
      return this.tiktokConnectUrl;
    } else {
      return `/connect/475wnIKISUYzQ7dUVEGfsAJzTGi1/4cdf1156-f12a-49d7-b6b8-d6c40d2638a0`;
    }
  }


  launchInstagram() {
    console.log('launchInstagram()');
    if (this.hasPlatformConnected({title: 'Instagram', icon: '../../../assets/instagram.webp', action: 'instagram'})) {
      this.alreadyConnected({title: 'Instagram', icon: '../../../assets/instagram.webp', action: 'instagram'});
      return;
    }
    const clientId = environment.instagram.clientId;
    const redirectUri = environment.instagram.redirectUri;

    console.log('clientId: ', clientId);
    console.log('redirectUri: ', redirectUri);

    /** 2. Encode redirectUri, disaply API only, result pending.. */
      // const authUrl = `https://www.instagram.com/oauth/authorize?force_authentication=1&client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=code&scope=instagram_business_basic,instagram_business_manage_messages,instagram_business_manage_comments,instagram_business_content_publish,instagram_business_manage_insights`;
      // const authUrl = `https://www.instagram.com/oauth/authorize?force_authentication=1&client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=instagram_business_basic,instagram_business_manage_messages,instagram_business_manage_comments,instagram_business_content_publish,instagram_business_manage_insights`;
    const authUrl = `https://www.instagram.com/oauth/authorize?force_authentication=1&client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=instagram_business_basic,instagram_business_manage_insights`;

    console.log('authUrl: ', authUrl);
    window.location.href = authUrl;

  }

  launchMeta() {
    console.log('launchMeta()');
    if (this.hasPlatformConnected({title: 'Meta', icon: '../../../assets/instagram.webp', action: 'meta'})) {
      this.alreadyConnected({title: 'Meta', icon: '../../../assets/instagram.webp', action: 'meta'});
      return;
    }
    const clientId = environment.fbinstagram.clientId;
    const redirectUri = environment.fbinstagram.redirectUri;
    const authUrl = `https://www.facebook.com/v23.0/dialog/oauth?&display=page&client_id=${clientId}&redirect_uri=${redirectUri}&response_type=token&extras={"setup":{"channel":"IG_API_ONBOARDING"}}&scope=instagram_basic,instagram_manage_comments,instagram_manage_insights,pages_show_list,pages_read_engagement`;
    window.location.href = authUrl;

  }

  launchYoutube() {
    console.log('launchYoutube()');

    if (this.hasPlatformConnected({
      title: 'YouTube',
      icon: 'assets/youtube-logo.webp',
      action: 'youtube'
    })) {
      this.alreadyConnected({
        title: 'YouTube',
        icon: 'assets/youtube-logo.webp',
        action: 'youtube'
      });
      return;
    }

    // No OAuth for YouTube in this setup – just go to the manual entry screen
    this.router.navigate(['/enter-youtube']);
  }


  alreadyConnected(platform: { title: string, icon: string, action: string }) {
    console.log(`${platform} already connected`);
    this.alreadyConnectedError = platform;
  }

  getRedirect() {
    return environment.instagram.redirectUri;
  }

  incrementToggleCount() {
    this.toggleCount++;
    if (this.toggleCount > 7) {
      this.showToggle = true;
      this.toggleCount = 0;
    }
  }


  getAuthenticationModeClass(mode: 'authentic' | 'manual') {
    if (this.authentiationMode === mode) {
      return 'bg-indigo-100 dark:bg-indigo-500/20 text-indigo-700';
    } else {
      return 'text-gray-500 dark:text-gray-400 hover:text-gray-700';
    }
  }
}

